import { Component, OnInit, ViewChild } from '@angular/core';
import { BaseComponent } from '../classes/BaseComponent';
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { InfoService } from '../info.service';

@Component({
  selector: 'app-disclaimer',
  templateUrl: './disclaimer.component.html',
  styleUrls: ['./disclaimer.component.scss'],
  providers: [ InfoService ]
})
export class DisclaimerComponent extends BaseComponent implements OnInit {

  language:string = InternationalizationHelper.getTwoCharactersLanguage();
  @ViewChild("header", {static: false}) header;

  constructor(private infoService: InfoService) {
    super();
  }

  ngOnInit() {
    
  }

}
